import { BiChevronDown } from "react-icons/bi";
import { List } from "./list";
import { useGetBrands } from "../../../../../api/brands/getBrands";
import { useContext, useEffect, useRef, useState } from "react";
import { FilterDropdown } from "../../../../../components/filterDropdown";
import clsx from "clsx";
import { RmcContext } from "../../../../../components/context/RmcContext";

const filters = [
  {
    key: "Today",
    value: "daily",
  },
  {
    key: "This Week",
    value: "weekly",
  },
  {
    key: "This Month",
    value: "monthly",
  },
  {
    key: "All Time",
    value: "",
  },
];

export const LeadBoard = ({ primaryColor = "#FFD700" }) => {
  const [type, setType] = useState(filters[0]);
  const hasFetched = useRef(false);
  const { getBrandLeadBoard, leaderboardData, loadingAcheivements } =
    useGetBrands();
  const { brandId } = useContext(RmcContext);

  useEffect(() => {
    if (brandId && type) {
      hasFetched.current = true;
      getBrandLeadBoard(brandId, type.value);
    }
  }, [type]);

  return (
    <div className="mt-4 px-4">
      <div className="flex items-center gap-3 mb-5">
        <p className="text-sm font-medium text-[#FFFFFF80]">Filters:</p>
        <FilterDropdown
          options={filters}
          selectedOption={type}
          setSelectedOption={setType}
          selectedOptionClass={clsx(
            "rmc_select_selected",
            type?.value ? "text-white" : "text-gray-400"
          )}
          selectedClass="bg-[#1B2033]"
          dropdownClass="rmc_select_dropdown text-xs"
          optionsClass="rmc_select_options"
          trailingIcon={
            <BiChevronDown
              size={16}
              className="text-[#FFFFFF4D] transition-transform duration-200"
            />
          }
        />
      </div>

      <List data={leaderboardData} isloading={loadingAcheivements} primaryColor={primaryColor} />
    </div>
  );
};
